import { notification } from "antd";

/**
 * Shows an AntD notification based on response or custom message
 * @param {string} type - 'success', 'error', 'info', 'warning'
 * @param {Object|string} res - API response object or custom message string
 * @param {string} description - optional description for the notification
 */
export const showSnackbar = (type = "success", res = "", description = "") => {
  let messageText = "";

  // Determine the message based on API response
  if (typeof res === "string") {
    messageText = res;
  } else if (res?.msg) {
    messageText = res.msg;
  } else if (res?.data) {
    messageText = res.data;
  } else if (res?.Status) {
    messageText = res.Status; // <-- added support for Status key
  } else {
    messageText = "Action completed";
  }

  // Validate notification type
  if (!notification[type]) {
    console.error(`Notification type "${type}" does not exist`);
    return;
  }

  // Show the notification
  notification[type]({
    message: messageText,
    description,
    placement: "topRight",
    duration: 2,
  });
};
